import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { searchAccounts as searchAccountsApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import { ACCOUNT_RETRIEVAL_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'
import { clearAccountDetails } from './clearAccountDetails'
import { History } from 'history'
import { isPrimitiveEmpty } from '../utils'
import { RoutesEnum } from '../types/RoutesEnum'
import { clearAccountSearch } from './clearAccountSearch'

export const SEARCH_ACCOUNTS = 'SEARCH_ACCOUNTS'
export const SEARCH_ACCOUNTS_SUCCESS = 'SEARCH_ACCOUNTS_SUCCESS'
export const SEARCH_ACCOUNTS_FAILURE = 'SEARCH_ACCOUNTS_FAILURE'

export const searchAccounts = (
  dispatch: Dispatch,
  searchTerm: string,
  history: History
) => {
  dispatch({ type: SEARCH_ACCOUNTS, searchTerm })
  clearAccountDetails(dispatch)
  searchAccountsApi(searchTerm)
    .then(({ data: accountResults }: AxiosResponse) => {
      dispatch({ type: SEARCH_ACCOUNTS_SUCCESS, accountResults })
      if (
        accountResults.length === 1 &&
        searchTerm.toUpperCase() ===
          accountResults[0].accountNumber.toUpperCase()
      ) {
        const accountNumber = accountResults[0]?.accountNumber
        if (!isPrimitiveEmpty(accountNumber)) {
          clearAccountSearch(dispatch)
          history.push(`/${RoutesEnum.InitiateTransfer}/${accountNumber}`)
        }
      } else {
        history.replace(
          `${history.location.pathname}?q=${encodeURIComponent(searchTerm)}`
        )
      }
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : ACCOUNT_RETRIEVAL_FAILED
      dispatch({ type: SEARCH_ACCOUNTS_FAILURE, errorMessage })
    })
}
